module.exports = __webpack_public_path__ + "ai.svg?101c87c14170fb406a26349aeb008e36";